import { render } from "./Nyukinyoteilist.vue?vue&type=template&id=2cd34e8a&ts=true"
import script from "./Nyukinyoteilist.vue?vue&type=script&lang=ts"
export * from "./Nyukinyoteilist.vue?vue&type=script&lang=ts"

import "./Nyukinyoteilist.vue?vue&type=style&index=0&id=2cd34e8a&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__